import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
// Import Bootstrap an BootstrapVue CSS files (order is important)
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
import "./plugins/bootstrap-vue";
import App from "./App.vue";

import Multiselect from "vue-multiselect";

Vue.config.productionTip = false;
Vue.component("multiselect", Multiselect);
// import { BootstrapVue , IconsPlugin  } from "bootstrap-vue";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin);
import {
  BootstrapVue,
  BIconstack,
  BIcon,
  BIconChevronDown,
  BIconCircle,
  BIconArrowUp,
  BIconArrowDown,
  BIconInfoCircle,
  BIconExclamationCircleFill,
} from "bootstrap-vue";
Vue.component("BIcon", BIcon);
Vue.component("BIconExclamationCircleFill", BIconExclamationCircleFill);
Vue.component("BIconChevronDown", BIconChevronDown);
Vue.component("BIconCircle", BIconCircle);
Vue.component("BIconArrowUp", BIconArrowUp);
Vue.component("BIconArrowDown", BIconArrowDown);
Vue.component("BIconInfoCircle", BIconInfoCircle);
Vue.component("BIconstack", BIconstack);

//chevron-down , circle, exclamation-circle-fill, arrow-up, arrow-down

new Vue({
  render: (h) => h(App),
}).$mount("#app");
